/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ details: NonNullable<unknown> }} Error_Loading_Country_DataInputs */

const bn_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`দেশের ডেটা লোড করতে ব্যর্থ হয়েছে: ${i?.details}`)
};

const de_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Länderdaten konnten nicht geladen werden: ${i?.details}`)
};

const el_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Αποτυχία φόρτωσης δεδομένων χώρας: ${i?.details}`)
};

const en_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load country data: ${i?.details}`)
};

const es_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los datos del país: ${i?.details}`)
};

const fr_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du chargement des données de pays : ${i?.details}`)
};

const hi_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`देश का डेटा लोड करने में विफल: ${i?.details}`)
};

const hu_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nem sikerült betölteni az ország adatait: ${i?.details}`)
};

const id_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gagal memuat data negara: ${i?.details}`)
};

const it_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i dati del paese: ${i?.details}`)
};

const ja_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`国データのロードに失敗しました: ${i?.details}`)
};

const ko_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`국가 데이터를 로드하지 못했습니다: ${i?.details}`)
};

const nl_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kan landgegevens niet laden: ${i?.details}`)
};

const pl_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nie udało się załadować danych kraju: ${i?.details}`)
};

const pt_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar dados do país: ${i?.details}`)
};

const ru_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить данные о стране: ${i?.details}.`)
};

const sv_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Det gick inte att läsa in landsdata: ${i?.details}`)
};

const tr_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ülke verileri yüklenemedi: ${i?.details}`)
};

const uk_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити дані країни: ${i?.details}`)
};

const vi_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không tải được dữ liệu quốc gia: ${i?.details}`)
};

const zh_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法加载国家/地区数据：${i?.details}`)
};

const zh_hant_error_loading_country_data = /** @type {(inputs: Error_Loading_Country_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無法載入國家/地區資料：${i?.details}`)
};

/**
* | output |
* | --- |
* | "Failed to load country data: {details}" |
*
* @param {Error_Loading_Country_DataInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const error_loading_country_data = /** @type {((inputs: Error_Loading_Country_DataInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Loading_Country_DataInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_error_loading_country_data(inputs)
	if (locale === "de") return de_error_loading_country_data(inputs)
	if (locale === "el") return el_error_loading_country_data(inputs)
	if (locale === "en") return en_error_loading_country_data(inputs)
	if (locale === "es") return es_error_loading_country_data(inputs)
	if (locale === "fr") return fr_error_loading_country_data(inputs)
	if (locale === "hi") return hi_error_loading_country_data(inputs)
	if (locale === "hu") return hu_error_loading_country_data(inputs)
	if (locale === "id") return id_error_loading_country_data(inputs)
	if (locale === "it") return it_error_loading_country_data(inputs)
	if (locale === "ja") return ja_error_loading_country_data(inputs)
	if (locale === "ko") return ko_error_loading_country_data(inputs)
	if (locale === "nl") return nl_error_loading_country_data(inputs)
	if (locale === "pl") return pl_error_loading_country_data(inputs)
	if (locale === "pt") return pt_error_loading_country_data(inputs)
	if (locale === "ru") return ru_error_loading_country_data(inputs)
	if (locale === "sv") return sv_error_loading_country_data(inputs)
	if (locale === "tr") return tr_error_loading_country_data(inputs)
	if (locale === "uk") return uk_error_loading_country_data(inputs)
	if (locale === "vi") return vi_error_loading_country_data(inputs)
	if (locale === "zh") return zh_error_loading_country_data(inputs)
	return zh_hant_error_loading_country_data(inputs)
});